import React from "react";
import PropTypes from "prop-types";
import DraftHTML from "./draftEditor/export/DraftHTML";
import Link from "next/link";
import { sortNumberArray } from "../helpers/common";
import Input from "./Input";
import RadioButton from "./RadioButton";

export default function FormDynamic({
                                        form,
                                        values, onChange,
                                        errors, setErrors,
                                        createInternalHelpLink,
                                        // custom
                                        custom, isForm,
                                        messages,
                                        ...props
                                    }) {

    const _onChange = (e, field) => {

        const {name, value} = e.target;
        let newError = null;

        if ((!!parseFloat(field.maxLength) || !!parseFloat(field.minLength)) && value.length && !('messages' in props)) {
            if (value.length < parseFloat(field.minLength)) newError = `Minimum length is ${field.minLength} characters`;
            if (value.length > parseFloat(field.maxLength)) newError = `Maximum length is ${field.maxLength} characters`;
        }

        onChange({...values, ...{[name]: value}})
        setErrors({...errors, ...{[name]: newError}})
    };

    const _onChangeRadio = (e) => {
        const {name, value} = e.target;
        onChange({...values, ...{[name]: value}})
    };

    const renderFieldPreview = (item, index) => {

        const {hint} = item;
        let hintContent = null;
        let showHint = false;

        if (!!hint?.blocks?.some(b => !!b.text)) {
            hintContent = <DraftHTML content={hint || null}/>;
            showHint = true;
        }

        if (!!item.internalHelp) {
            hintContent = (
                (<Link
                    href={createInternalHelpLink(item)}
                    className='df__field__internal-help'
                    target='_blank'>

                    {item.internalHelp}

                </Link>)
            );
            showHint = true;
        }

        return (
            <Input
                id={`anchor-${item.name}`}
                className={`df__field${!!item.required && !values[item.name] && (!custom || !!custom && !!isForm) && !('messages' in props) ? ' df__input-warn' : ''}`}
                name={item.name}
                value={values[item.name]}
                onChange={e => _onChange(e, item)}
                iconLeft={item.icon}
                type={item.typeHTML || 'text'}
                required={item.required}
                placeholder={item.label || item.name || 'undefined name or label'}
                hint={showHint && hintContent}
                isValid={!errors?.[item.name] ? (!!values[item.name]?.length || !item.required || !!custom && !isForm || ('messages' in props)) ? undefined : false : false}
                error={!!custom && !isForm ? undefined : errors?.[item.name]}
                showBlockHintOnError={['html5']}
                maxLength={!isNaN(parseFloat(item.maxLength)) ? parseFloat(item.maxLength) : 0}
                minLength={!isNaN(parseFloat(item.minLength)) ? parseFloat(item.minLength) : 0}
                autoComplete="one-time-code"
                key={index}
                messages={messages}
                visualVariables={{
                    colorIcon: 'var(--colorFontDisabled)',
                    height: '5rem',
                    colorBorder: 'transparent',
                    colorBackground: 'var(--colorBackgroundBasic)',
                }}
            />
        )
    }

    const renderGuidePreview = (item, index) => {
        return (
            <div className='df__guide' key={index}>
                <div className='df__guide__content'>
                    <i
                        className={`${item.icon || 'fas fa-question-circle'} df__guide__content__icon`}
                        aria-hidden="true"
                    />
                    {
                        !!item.text &&
                        <DraftHTML
                            className='df__guide__content__text'
                            content={item.text ? item.text : null}
                            styles={{'unstyled': 'df__guide__content__text__unstyled'}}
                        />
                    }
                </div>
            </div>
        )
    }

    const renderNotePreview = (item, index) => {
        return (
            <div className='df__note' key={index}>
                <div className='df__note__content'>
                    <div className='df__note__content__head'>
                        <i
                            className={`${item.icon || 'fas fa-exclamation-circle'} df__note__content__head__icon`}
                            aria-hidden="true"
                        />
                        <h3 className='df__note__content__head__title'>{item.title || 'Important note!'}</h3>
                    </div>
                    <div className='df__note__content__body'>
                        {
                            !!item.text &&
                            <DraftHTML
                                className='df__note__content__body__text'
                                content={item.text || null}
                                styles={{'unstyled': 'df__note__content__body__text__unstyled'}}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }

    const renderRadioPreview = (item, index) => {
        return (
            <RadioButton
                title={item.title}
                description={item.description}
                name={item.name}
                onChange={_onChangeRadio}
                options={Object.values(item.options || {}) || []}
                value={values[item.name]}
                messages={messages}
                id={`${item.name}-${item.type}-${item.id}`}
                key={item.id}
            />
        )
    }

    form = sortNumberArray(form, false, 'order');

    return (
        <>
            {
                form.map((item, index) => {
                    switch (item.type) {
                        case 'field':
                            return renderFieldPreview(item, index);
                        case 'guide':
                            return renderGuidePreview(item, index);
                        case 'note' :
                            return renderNotePreview(item, index);
                        case 'radio' :
                            return renderRadioPreview(item, index);
                        default:
                            return null;
                    }
                })
            }
        </>
    )
}

FormDynamic.propTypes = {
    form: PropTypes.array.isRequired,
    errors: PropTypes.object, // { [name]: 'message' }
    setErrors: PropTypes.func,
    values: PropTypes.object.isRequired, // { [name]: 'value' }
    onChange: PropTypes.func.isRequired,
    createInternalHelpLink: PropTypes.func,
}